/**
 * Resolve a renderer type from a string, `{ type }`, or a Java map-entry list.
 *
 * Customer DMs use WebLink variants (e.g. BasicUdiDiWebLink, UdiDiWebLink)
 * with Angular Grid-* templates; treat any type ending in "WebLink" as a link.
 * Prefer either rendererParams or the DM renderer — Angular setInputRenderer may
 * write a fallback type of "String" onto shared attribute objects.
 */
export function resolveRendererType(renderer: unknown): string | undefined {
    if (typeof renderer === 'string') {
        return renderer;
    }
    if (!renderer || typeof renderer !== 'object') {
        return undefined;
    }
    const asRecord = renderer as { type?: unknown };
    if (typeof asRecord.type === 'string') {
        return asRecord.type;
    }
    if (Array.isArray(renderer)) {
        const typeEntry = renderer.find(
            (entry: { key?: unknown; value?: unknown }) => entry?.key === 'type'
        );
        if (typeof typeEntry?.value === 'string') {
            return typeEntry.value;
        }
    }
    return undefined;
}

export function isWebLinkRenderer(attr: { params?: { rendererParams?: unknown; customRenderer?: unknown; renderer?: unknown } } | null | undefined): boolean {
    const candidates = [
        resolveRendererType(attr?.params?.rendererParams),
        resolveRendererType(attr?.params?.customRenderer ?? attr?.params?.renderer),
    ];
    return candidates.some(
        (type) => typeof type === 'string' && type.endsWith('WebLink')
    );
}
